import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';

// import core components
import { queryHelper } from 'helpers';
import { useOnClickOutside } from "hooks";

const Menu = styled.div`
  padding-left: 10px;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    display: none;
  }
`;

const MenuButton = styled.a`
  font-weight: ${props => props.theme.fontWeight.button};  
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 10px;
  height: 45px;
  width: 170px;
  text-transform: uppercase;
  background-color: ${props => props.theme.colors.lightBlue};
  color: ${props => props.theme.colors.blue};
  font-weight: ${props => props.theme.fontWeights.button};
  border-radius: ${props => props.theme.borderRadius.round};
  outline: none;
  border: none;
  cursor: pointer;
  > a {
    margin: auto;
  }
`

const DropDownButton = styled.a`
  font-weight: ${props => props.theme.fontWeight.button};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 10px;
  height: 45px;
  width: 100px;
  text-transform: uppercase;
  background-color: ${props => props.theme.colors.lightBlue};
  color: ${props => props.theme.colors.blue};
  font-weight: ${props => props.theme.fontWeights.button};
  border-radius: ${props => props.theme.borderRadius.round};
  outline: none;
  border: none;
  cursor: pointer;

  &:after {
    content: '';
    display: inline-block;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid ${props => props.theme.colors.blue};
    margin-left: 5px;
  }
  &.active {
    &:after {
      border-top: none;
      border-bottom: 8px solid ${props => props.theme.colors.blue};
      margin-left: 5px;
    }
  }
`;
const MenuWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 60px;
  width: 100%;
  z-index: 39999;
  padding-top: 3px;
`;
const MenuContainer = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadow.menu};
  border-radius: ${props => props.theme.borderRadius.default};
  margin: 7px 0px;
  padding: 30px 0px;
  justify-content: center;
`;
const ItemContainer = styled.div`
  background-color: ${props => props.theme.colors.white};
  border-right: 0.5px solid ${props => props.theme.colors.stroke};
  color: ${props => props.theme.colors.blue};
  padding: 0px 35px;
  &:last-child {
    border: 0 !important;
  }
  width: ${props => `${100 / props.columns}%`};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ItemHeader = styled.a`
  font-family: Montserrat;
  font-size: 16px;
  line-height: 45px;
  font-weight: bold;
`;
const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;
  > a {
    font-family: Montserrat;
    font-size: 14px;
    line-height: 44px;
    list-style-type: none;
    margin-bottom: 0px;
    cursor: pointer;
    color: ${props => props.theme.colors.blue};
    &:hover {
      color: ${props => props.theme.colors.black};
    }
  }
`;
const MenuBar = styled.div`  
  display: flex;  
`

const MegaMenu = ({ title, data }) => {
  const [showMegaMenu, setShowMegaMenu] = React.useState(false);
  const megaMenuRef = useRef(null); // Ref to detect outside click
  useOnClickOutside(megaMenuRef, () => setShowMegaMenu(false));

  return (
    <MenuBar>
      <Menu ref={megaMenuRef}>
        {<DropDownButton
          onClick={() => setShowMegaMenu(!showMegaMenu)}
          className={showMegaMenu ? 'active' : ''}
        >
          {title}
        </DropDownButton>}      
        <MenuWrapper
          className={showMegaMenu ? 'visible' : 'non-visible'}
        >
          <MenuContainer>
            {data.map((menu, index) => {
              return (
                <ItemContainer key={menu.title} columns={data.length}>
                  <div>
                    <ItemHeader>{menu.description}</ItemHeader>
                    <ItemContent>
                      {menu.children
                        .filter(submenu => submenu.enabled)
                        .map((submenu, i) => {
                          return (
                            <Link
                              key={submenu.title}
                              to={queryHelper.getLinkUrl(submenu.link)}
                            >
                              {submenu.description}
                            </Link>
                          );
                        })}
                    </ItemContent>
                  </div>
                </ItemContainer>
              );
            })}
          </MenuContainer>
        </MenuWrapper>      
      </Menu>
    </MenuBar>
  );
};

export default MegaMenu;
